import React from 'react';

import {
  Container as MuiContainer,
  styled
} from '@mui/material';



const Container = styled(MuiContainer)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});


export interface IProps {
  marginBottom?: number | string;
  marginTop?: number | string
  horizontalMargin?: number | string;

  children?: React.ReactNode | React.ReactNode[];
}

export const FC: React.FC<IProps> = props => {
  return (
    <Container style={{
      marginTop: props.marginTop,
      marginBottom: props.marginBottom,
      marginLeft: props.horizontalMargin,
      marginRight: props.horizontalMargin
    }}>
      {props.children}
    </Container>
  );
};
